import React, { useEffect, useState } from "react"
import { Link, navigate } from "gatsby"
import linkBuilder from "../../modules/linkBuilder"
import { GatsbyImage } from "gatsby-plugin-image"
import {
  popoverPanel,
  popoverContent,
  sidebar,
  sidebarList,
  sidebarNavList,
  sidebarListItem,
  sidebarWrapper,
  activeListItem,
  tabContent,
  tabCard,
  cardLink,
  cardTitle,
  adContainer,
  adTitle,
  adImage,
  adButton,
  adDivider,
  extraLinks,
  tabCardExtraLinks,
} from "./mega-menu-expanded.module.css"
import { dataLayer, trackEvent } from "../../modules/analytics"

const MegaMenuExpanded = ({ clickRef, activeTab, setActiveTab, desks }) => {
  const [activeDesk, setActiveDesk] = useState(desks.find((x) => x.id === activeTab))

  useEffect(() => {
    setActiveDesk(desks.find((x) => x.id === activeTab))
  }, [activeTab])

  return (
    <>
      <div ref={clickRef} className={popoverPanel}>
        <div className={popoverContent} style={{ maxHeight: '80vh' }}>
          {/* Sidebar */}
          <div className={sidebarWrapper}>
            <div className={sidebar}>
              <div className={sidebarList}>
                <div className={sidebarNavList}>
                  {desks.map((item) => (
                    <p
                      key={item.id}
                      className={
                        activeTab === item.id ? activeListItem : sidebarListItem
                      }
                      onClick={() => {
                        setActiveTab(item.id)
                        trackEvent(`nav_megamenu_hero`)
                      }}
                    >
                      {item.name}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Tab content */}
          <div
            className={tabContent}
            style={{ overflowY: "scroll", overflowX: "hidden" }}
          >
            {activeDesk?.deskcategory.map((deskcategory) => {
              return (
                <div key={deskcategory.id} className={tabCard}>
                  <Link
                    className={cardTitle}
                    href={linkBuilder.deskCategory(deskcategory)}
                    onClick={() => trackEvent('nav_megamenu_hub')}
                  >
                    {deskcategory.name}
                  </Link>
                  <ul style={{ padding: 0 }}>
                    {deskcategory.article
                      ?.filter((article) => {
                        return article.categories?.find(
                          (cat) => cat.slug2 === deskcategory.slug2
                        )
                      })
                      .sort(
                        (a, b) =>
                          new Date(a.updateDate).getTime() -
                          new Date(b.updateDate).getTime()
                      )
                      .reverse()
                      .slice(0, 3)
                      .map((article) => (
                        <li key={article.id} style={{ display: "flex" }}>
                          <Link
                            className={cardLink}
                            href={linkBuilder.article(article)}
                            onClick={() => trackEvent(`nav_megamenu_article`)}
                          >
                            {article.title}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              )
            })}
            <div className={tabCardExtraLinks}>
              <hr className={adDivider} />
              <div className={extraLinks}>
                <Link
                  onClick={() => trackEvent(`nav_megamenu_link`)}
                  to="/nieuws/mkb-servicedesk/over-mkb-servicedesk"
                >
                  Over ons
                </Link>
                <Link
                  onClick={() => trackEvent(`nav_megamenu_link`)}
                  to="/nieuws/mkb-servicedesk/contact-mkb-servicedesk"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>

          {/* Side CTA */}
          <div className={adContainer}>
            {activeDesk?.ctaNavigation && (
              <>
                <span className={adTitle}>
                  {activeDesk.ctaNavigation.title}
                </span>
                <GatsbyImage
                  className={adImage}
                  image={activeDesk.ctaNavigation.image.gatsbyImageData}
                  alt={
                    activeDesk.ctaNavigation.image.title
                      ? activeDesk.ctaNavigation.image.title
                      : ""
                  }
                />

                <Link
                  className={adButton}
                  to={linkBuilder.download(activeDesk?.ctaNavigation)}
                  onClick={() => trackEvent(`nav_megamenu_cta`)}
                >
                  Download {activeDesk.ctaNavigation.downloadType}
                </Link>
                <hr className={adDivider} />
              </>
            )}

            {/* Temporary placeholder for CTA */}
            {!activeDesk?.ctaNavigation && (
              <>
                <span className={adTitle}>Lorem ipsum dolor sit amet.</span>
                <img
                  className={adImage}
                  src="https://via.placeholder.com/300x200"
                  alt={"Placeholder Image"}
                />

                <Link className={adButton} to={"#"}>
                  Download
                </Link>
                <hr className={adDivider} />
              </>
            )}

            <div className={extraLinks}>
              <Link to="/nieuws/mkb-servicedesk/over-mkb-servicedesk">Over ons</Link>
              <Link to="/nieuws/mkb-servicedesk/contact-mkb-servicedesk">Contact</Link>
            </div>
          </div>
        </div>

        {/* Line at bottom */}
        <div
          style={{ width: "100%", height: "40px", backgroundColor: "#EDEDED" }}
        />
      </div>
    </>
  )
}

export default MegaMenuExpanded
